export enum StatusTorneio {
    AGENDADO = 'AGENDADO',
    INSCRICOES_ABERTAS = 'INSCRICOES_ABERTAS',
    INSCRICOES_ENCERRADAS = 'INSCRICOES_ENCERRADAS',
    ENCERRADO = 'ENCERRADO',
    CANCELADO = 'CANCELADO',
    POSTERGADO = 'POSTERGADO'
}